import { TFirestoreTimestamp } from "common/types/FirebaseTypes";
export class CostPlan {
  description: string;
  fileName: string;
  message?: string;
  name: string;
  progress: number;
  status: string;
  type?: string;
  wbsProjectBudget: string | null;
  projectBound: string | null;
  modifyAt?: TFirestoreTimestamp;
  fields?: any;
  structCodeColumn?: any;
  alternativeCodeColumn?: any;
  descriptionColumn?: any;
  quantityColumn?: any;
  coefficientColumn?: any;
  unitColumn?: any;
  unitCostColumn?: any;
  customProperties?: Object;
  columnNotFound?: string;
  wbsId?: string;
  wbsName?: string;
  wbsCreatedAt?: TFirestoreTimestamp;

  constructor(
    description: string,
    fileName: string,
    name: string,
    progress: number,
    status: string,
    wbsProjectBudget: string,
    projectBound: string,
    message?: string,
    type?: string,
    modifyAt?: TFirestoreTimestamp,
    structCodeColumn?: any, // structCodeColumn
    alternativeCodeColumn?: any, // alternativeCodeColumn
    descriptionColumn?: any, // descriptionColumn
    unitColumn?: any, // unitColumn
    unitCostColumn?: any, // unitCostColumn
    quantityColumn?: any, // quantityColumn
    coefficientColumn?: any, //coefficientColumn
    customProperties?: Object,
    wbsId?: string,
    wbsName?: string,
    wbsCreatedAt?: TFirestoreTimestamp
  ) {
    // customProperties

    this.description = description;
    this.fileName = fileName;
    this.name = name;
    this.progress = progress;
    this.status = status;
    this.wbsProjectBudget = wbsProjectBudget;
    this.projectBound = projectBound;
    this.message = message;
    this.type = type;
    this.modifyAt = modifyAt;
    this.structCodeColumn = structCodeColumn;
    this.alternativeCodeColumn = alternativeCodeColumn;
    this.descriptionColumn = descriptionColumn;
    this.unitColumn = unitColumn;
    this.unitCostColumn = unitCostColumn;
    this.quantityColumn = quantityColumn;
    this.coefficientColumn = coefficientColumn;
    this.customProperties = customProperties;
    this.wbsId = wbsId;
    this.wbsName = wbsName;
    this.wbsCreatedAt = wbsCreatedAt;
  }

  public static getDefault(): CostPlan {
    return new CostPlan("", "", "", 0, "", "", "");
  }
}



// WEBPACK FOOTER //
// ./src/modules/costPlan/models/CostPlan.ts